// extracted by mini-css-extract-plugin
export default {"app":"mainlayout_app__7mE7B","content":"mainlayout_content__Kbwnf"};